import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useState } from "react";
import "../../components/CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";

import { CssBaseline } from "@material-ui/core";


import ConfirmationDialog from "../ConfirmationDialog";
import { setTemplate } from "../../redux/slices/templateSlice";
import { Schedule } from "@mui/icons-material";
import { setMeeting } from "../../redux/slices/meetingSlice";
import EditScheduleForm from "./EditScheduleForm";
import { setSelectedLayoutLogout } from "../../redux/slices/selectedLayoutSlice";
import { toast } from "react-toastify";
import { checkPrivileges } from "./Helpers/CheckPrivelges";
import TableStatus from "../TableStatus";

const theme = createMuiTheme({
  spacing: 5,
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
      width: "100%",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),

    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "relative ",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",
    marginTop: "10%",
    borderRadius: "5px",
  },
}));

const ScheduleTable = ({ selectedOption, responseData, errors, isLoading }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const meetingData = useSelector((state) => state.meeting);
  const headers = useSelector((state) => state?.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const meetingspaces = useSelector(
    (state) => state?.allmeetingspaces?.allmeetingspaces
  );
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [currentHtmlContent, setCurrentHtmlContent] = useState("");
  const templateData = useSelector((state) => state.template);
  const templates = templateData?.template;
  const [maker, setMaker] = useState("");
  const handleViewTemplate = (htmlContent) => {
    setCurrentHtmlContent(htmlContent || "<div>No Content Available</div>");
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setCurrentHtmlContent("");
  };

  const columns = [
    {
      field: "name",
      headerName: "Event/meeting Name",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "user",
      headerName: "Host Name",
      flex: 0.7,
      minWidth: 120,
    },
    {
      field: "roomId",
      headerName: "Room",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const room = meetingspaces?.find((space) => space.id === params.value);
        return room ? room.name : "Unknown";
      },
    },
    {
      field: "Maker",
      headerName: "Schedule Maker",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return params?.row?.customProperties?.audit?.contentAiScheduleMaker;
      },
    },
    {
      field: "Editor",
      headerName: "Schedule Editor",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return params?.row?.customProperties?.audit?.contentAiScheduleEditor;
      },
    },
    {
      field: "startTime",
      headerName: "Start Time (IST)",
      flex: 1,
      minWidth: 160,
      valueGetter: (params) => {
        if (!params) return "";

        const date = new Date(params);
        if (isNaN(date.getTime())) return "Invalid Date";

        return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
      },
    },
    {
      field: "endTime",
      headerName: "End Time (IST)",
      flex: 1,
      minWidth: 160,
      valueGetter: (params) => {
        if (!params) return "";

        const date = new Date(params);
        if (isNaN(date.getTime())) return "Invalid Date";

        return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
      },
    },

    ,
    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      minWidth: 110,
      sortable: false,
      renderCell: (params) => {
        const maker =
          params.row?.customProperties?.audit?.contentAiScheduleMaker;
        return (
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            color="primary"
            onClick={() => {
              handleEdit(params.row, maker);
            }}
          >
            Edit
          </Button>
        );
      },
    },

    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1.2,
      minWidth: 150,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => {
            handleDelete(params.row.id);
            setMaker(params.row.customProperties.audit.contentAiScheduleMaker);
          }}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
  ];

  const handleEdit = async (schedule, maker) => {
    const hasRights = await checkPrivileges(
      maker,
      groupIdsOfUser,
      api,
      headers
    );

    if (!hasRights) {
      toast.error("Access Denied", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    setSelectedSchedule(schedule);
    setEditModalOpen(true);
  };
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);
    const requestBody = {
      path: "meeting",
      query: { meetingId: `${deleteItemId}` },
      emmsId: selectedOption,

      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        setRows((prevRows) => {
          const updatedRows = prevRows?.filter(
            (row) => row.id !== deleteItemId
          );

          dispatch(setMeeting(updatedRows));
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const user = useSelector((state) => state?.user?.user);
  const groupIdsOfUser = user?.customProperties?.belongsTo || [];

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  React.useEffect(() => {
    if (meetingData?.meeting) setRows(meetingData?.meeting);
  }, [meetingData?.meeting]);

  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider>
            <div className="emms-data-grid-container" style={{ padding: "2.5% 10%", overflowX: "auto" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>

            {showConfirmationDialog && (
              <ConfirmationDialog
                open={showConfirmationDialog}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
                contentAI={true}
                maker={maker}
              />
            )}
            <EditScheduleForm
              open={editModalOpen}
              handleEditModalClose={() => {
                dispatch(setSelectedLayoutLogout());
                setEditModalOpen(false);
              }}
              scheduleData={selectedSchedule}
            />
            <Dialog
              open={openViewModal}
              onClose={handleCloseViewModal}
              maxWidth="md"
              sx={{
                "& .MuiDialog-paper": {
                  width: "auto",
                  height: "auto",
                  maxWidth: "80vw",
                  maxHeight: "95vh",
                  borderRadius: "15px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                  overflow: "hidden",
                  padding: "2",
                },
              }}
            >
              <DialogActions
                sx={{
                  padding: "12px 16px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton
                  onClick={handleCloseViewModal}
                  sx={{
                    color: "gray",
                    fontSize: "1.5rem",
                    padding: "8px",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogActions>

              <DialogContent
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  overflow: "hidden",
                  alignItems: "center",
                  padding: "0", 
                }}
              >
                <iframe
                  srcDoc={currentHtmlContent} 
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none", 
                    borderRadius: "12px", 
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", 
                    backgroundColor: "#fff",
                    overflow: "auto",
                    minHeight: "500px", 
                    minWidth: "640px", 
                  }}
                />
              </DialogContent>
            </Dialog>
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};

export default ScheduleTable;
